import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import DefaultViewHeader from "../../components/main/default_view_header/DefaultViewHeader";
import "./style.scss";
import SettingsAside from "../../components/settings/settings_aside/SettingsAside";
import DeviceSettings from "../../components/settings/settings_block/DeviceSettings";
import HomeSettings from "../../components/settings/settings_block/HomeSettings";
import { mapDispatchToProps, mapStateToProps } from "../../store/dispatcher";
import { connect } from "react-redux";
import { DispatchProps, StateProps } from "../../store";
import { Device, isDeviceDetailLoaded } from "../../lib/Device";
import { Home, isHomeDetailLoaded } from "../../lib/Home";
import { useTranslation } from "react-i18next";

const Settings = ({
  devices,
  homes,
  fetchDevice,
  fetchHome,
}: {
  devices: Device[];
  homes: Home[];
  fetchDevice: (id: number) => void;
  fetchHome: (id: number) => void;
}) => {
  const { home_id, device_id } = useParams();
  const { t } = useTranslation("settings");

  const parsedDeviceId = parseInt(device_id ? device_id : "0");
  const parsedHomeId = parseInt(home_id ? home_id : "0");

  const currentDevice = devices?.find((device) => device.id === parsedDeviceId);
  const currentHome = homes?.find((home) => home.id === parsedHomeId);

  useEffect(() => {
    if (parsedDeviceId && !isDeviceDetailLoaded(currentDevice)) {
      fetchDevice(parsedDeviceId);
    }
  }, [parsedDeviceId, currentDevice, fetchDevice]);

  useEffect(() => {
    if (parsedHomeId && !isHomeDetailLoaded(currentHome)) {
      fetchHome(parsedHomeId);
    }
  }, [parsedHomeId, currentHome, fetchHome]);

  return (
    <div id="settings-view">
      <DefaultViewHeader
        title={
          device_id ? t("settings_device_title") : t("settings_home_title")
        }
        description={
          device_id
            ? t("settings_device_description")
            : t("settings_home_description")
        }
      />
      <div className="settings-content">
        <SettingsAside />
        {device_id &&
          devices !== null &&
          (isDeviceDetailLoaded(currentDevice) ? (
            <DeviceSettings device={currentDevice!} />
          ) : currentDevice ? null : (
            <div className="empty-item">
              <span>{t("device_not_found")}</span>
            </div>
          ))}
        {!device_id &&
          home_id &&
          homes !== null &&
          (isHomeDetailLoaded(currentHome) ? (
            <HomeSettings
              devices={devices}
              home={currentHome!}
            />
          ) : currentHome ? null : (
            <div className="empty-item">
              <span>{t("home_not_found")}</span>
            </div>
          ))}
      </div>
    </div>
  );
};

export default connect<StateProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(Settings);
